// No 'use server' directive: these wrappers are imported into client
// components and run in the browser, where relative URLs resolve against the
// current origin and the user's session cookie is sent automatically. Making
// the file a Server Action module would force the fetch onto the server,
// where relative URLs fail (Node Request requires absolute) and cookies
// would have to be forwarded manually. See Hub/routeHandlerService/projects.ts
// for the same pattern.

export async function getProfile_rh() {
  const res = await fetch(`/api/skywatch/me`);
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;
  return response?.data;
}

export const offPlatformRequest_rh = async (formData: any) => {
  const res = await fetch(`/api/skywatch/off-platform/request`, {
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
  });
  const rhResponse: { json?: any; status?: number; error?: string; code?: string } =
    await res.json();

  if (!res.ok) {
    return { error: { message: rhResponse?.error, code: rhResponse?.code } };
  }

  const response = rhResponse?.json;

  if (response?.errors?.length > 0) {
    return { error: { message: response.errors[0]?.message } };
  }

  if ((rhResponse?.status ?? res.status) >= 400) {
    return { error: { message: response?.message } };
  }

  return { data: response?.data ?? response ?? {} };
};

export const getTaskingWindowsPublic_rh = async (formData: any, token: any) => {
  const res = await fetch(`/api/skywatch/tasking/windows`, {
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
  });
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  let data: any = {};
  if (response?.errors?.length > 0) {
    data['error'] = { message: response?.errors?.[0] || '' };
  } else {
    data['data'] = response;
  }
  return data;
};

// SkySat Assured Tasking (and any future Planet Assured product) uses the
// asynchronous two-step flow: POST to start the search, then GET the same
// search_id repeatedly until status is "done" or "failed". Both endpoints
// return the same `{errors?: string[], ...}` envelope as the sync
// /tasking/windows endpoint, so we mirror its data-shaping for consistency.

export const startTaskingWindowSearch_rh = async (formData: any) => {
  // Relative URL is intentional: Next.js server-side fetch forwards the
  // incoming request's cookies only for same-origin relative paths, which is
  // how the route handler picks up the Auth0 session. Using an absolute URL
  // (e.g. http://localhost:3000/...) silently breaks auth.
  const res = await fetch(`/api/skywatch/tasking/window-searches`, {
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
  });
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  let data: any = {};
  if (response?.errors?.length > 0) {
    data['error'] = { message: response?.errors?.[0] || '' };
  } else {
    data['data'] = response;
  }
  return data;
};

export const pollTaskingWindowSearch_rh = async (searchId: string) => {
  // See note on startTaskingWindowSearch_rh — relative URL needed for cookie
  // forwarding from the server-side fetch.
  const res = await fetch(`/api/skywatch/tasking/window-searches/${encodeURIComponent(searchId)}`);
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  let data: any = {};
  if (response?.errors?.length > 0) {
    data['error'] = { message: response?.errors?.[0] || '' };
  } else {
    data['data'] = response;
  }
  return data;
};
